import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {UserSessionService} from './user-session.service'

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    UserSessionService
  ],
  exports: []
})
export class ServicesModule {}
